<template>
  <el-dialog title="选择稿件" :visible.sync="_visible" width="720px">

    <el-table :data="dataSource" style="width: 100%">
      <el-table-column prop="title" show-overflow-tooltip label="标题" width="180">
      </el-table-column>

      <el-table-column prop="description" label="摘要" class-name="wrap">
      </el-table-column>

      <el-table-column prop="created_at" width="140" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.created_at|dateformat('YYYY-MM-DD HH:mm')}}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleSelect(scope.row.manuscript_id)">选择</el-button>
        </template>
      </el-table-column>

      <div slot="empty">
        暂无任何可供使用的稿件，
        <router-link class="link" :to="'/own/manuscripts/create/'+taxonomy+'?order_id='+order_id">前往创建</router-link>
      </div>
    </el-table>


    <el-pagination v-if="dataSource.length" style="text-align:center;margin-top:24px;" background layout="prev, pager, next" :total="pagination.total"
      :current-page="pagination.current_page" :page-size="pagination.per_page" @current-change="handleCurrentChange">
    </el-pagination>

  </el-dialog>
</template>

<script>
  import moment from "moment";
  import PaginationChange from '../../mixins/PaginationChange.vue'
  export default {
    mixins: [PaginationChange],
    props: {
      visible: {
        default: false,
        type: Boolean
      },
      order_id:{},
      taxonomy: {
        default: '',
        type: String
      },
    },
    data() {
      return {
        pageUrl: "/own/manuscripts",
        dataSource: [],
        value: "",
        date: "",
        pagination: {
          total: 0,
          per_page: 20,
          current_page: 0
        }
      };
    },
    computed: {
      _visible: {
        get() {
          return this.visible
        },
        set() {
          this.$emit('dialogHidden')
        }
      }
    },
    watch: {
      $route() {
        this.load()
      },
      taxonomy(v) {
        this.load();
      }
    },
    created() {
      this.load();
    },
    methods: {
      load() {
          this.dataSource = [];
          
          if(!this.taxonomy)
          {
              return false;
          }

        const params = {
          taxonomy: this.taxonomy,
          used_status: -1,
          page:this.pagination.current_page+1
        }
        this.$http.get("/manuscripts?" + this.objectToQuery(params)).then(response => {
          if (response.success) {
            this.dataSource = response.data;

            this.pagination = response.pagination;
          }
        })
      },
      handleCurrentChange(e) {
        this.pagination.current_page++;
        this.load()
      },
      handleSelect(id) {
        this.$confirm("是否选择当前稿件作为该订单的稿件", "提醒", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "处理中...";

              this.$http;
              this.$http
                .put("/order_resource/" + this.order_id, {
                  manuscript_id: id
                })
                .then(response => {
                  if (!response.success) {
                    instance.callback = () =>
                      this.$alert(response.message, "失败");
                  } else {
                    this._visible = false;
                    this.$emit('load')
                  }
                })
                .catch()
                .then(() => {
                  instance.confirmButtonLoading = false;
                  done();
                });
            } else {
              done();
            }
          }
        });
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/manuscript/Dialog.vue